import { LazoFile } from "@/models/LazoFile";
import DocumentCenterFileService from "@/services/DocumentCenterFileService";
import LazoFileService from "@/services/LazoFileService";
import ProductFlowDeliverableService from "@/services/ProductFlowDeliverableService";
import { Box, CardActions, CardContent, Container, IconButton, Menu, MenuItem, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import more from "../../../assets/images/more2.svg";
import FilePreview from "./FilePreview";

export const handleFileTypeByName = (fileName: string) => {
  const extension = fileName?.split(".").pop();

  const fileTypes = {
    pdf: "pdf",
    document: "doc",
    "application/pdf": "pdf",
    jpg: "image",
    jpeg: "image",
    png: "image",
    svg: "svg",
    "image/svg+xml": "svg",
    gif: "image",
    "image/png": "image",
    doc: "doc",
    docx: "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
    xls: "sheets",
    xlsx: "sheets",
    sheets: "sheets",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "sheets",
    ppt: "ppt",
    pptx: "ppt",
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "ppt",
    txt: "txt",
    md: "md",
    "text/markdown": "md",
    csv: "csv",
  };

  return fileTypes[extension || fileName] || "other";
};

export interface FilePreviewPopOverProps {
  fileExternalId?: string;
  position?: any;
  setHoveredFile?: (value: null) => void;
  hoveredRowId?: string;
  setUpdate?: (value: boolean) => void;
  update?: boolean;
  isDocumentCenter?: boolean;
  cellRef?: any;
}

export const FilePreviewPopOver = (props: FilePreviewPopOverProps) => {
  const [fileData, setFileData] = useState<LazoFile | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [preSignedUrl, setPreSignedUrl] = useState(null);
  const [fileType, setFileType] = useState("other");
  const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (props.fileExternalId) {
      handleSearchFile(props.fileExternalId);
      getPreSignedUrl(props.fileExternalId);
    }
  }, [props.fileExternalId]);

  const handleSearchFile = async (fileExternalId: string) => {
    if (!props.isDocumentCenter) {
      await LazoFileService.getFiles([fileExternalId]).then((response) => {
        response.onSuccess((data) => {
          setFileData(data[0]);
          setFileType(handleFileTypeByName(data[0].name));
        });
        response.onError((error) => {
          console.log(error);
        });
      });
    } else {
      await DocumentCenterFileService.getByDocumentCenterFileExternalId(fileExternalId).then((response) => {
        response.onSuccess((data) => {
          const lazoFile: LazoFile = {
            externalId: data.externalId,
            size: 0,
            submitterUser: data.owner,
            fileUrl: data.url,
            expirationDate: new Date(),
            name: data.name,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
          };
          setFileData(lazoFile);

          const fileName = data.keyName;
          setFileType(handleFileTypeByName(fileName));
        });
        response.onError((error) => {
          console.log(error);
        });
      });
    }
  };

  const getPreSignedUrl = async (fileExternalId: string) => {
    if (!props.isDocumentCenter) {
      await LazoFileService.generatePreSignedUrl(fileExternalId).then((response) => {
        response.onSuccess((data) => {
          setPreSignedUrl(data);
        });
        response.onError((error) => {
          console.log(error);
        });
      });
    } else {
      await DocumentCenterFileService.getPreSignedUrl(fileExternalId).then((response) => {
        response.onSuccess((data) => {
          setPreSignedUrl(data);
        });
        response.onError((error) => {
          console.log(error);
        });
      });
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadFile = (fileExternalId: string) => {
    LazoFileService.downloadFile(fileExternalId, fileData.name);
  };

  const handleDeleteFile = (fileExternalId: string, deliverableExternalId: string) => {
    ProductFlowDeliverableService.deleteDeliverableFile(deliverableExternalId, fileExternalId).then((response) => {
      response.onSuccess((data) => {
        props.setUpdate(!props.update);
      });
      response.onError((error) => {});
    });
  };
  return (
    <Container
      style={{
        top: !props.isDocumentCenter ? `${props.position?.top - 85}px` : `${props.cellRef.top - 220}px`,
        left: !props.isDocumentCenter ? `${props.position?.left - 25}px` : ``,

        position: "absolute",
        zIndex: 1,
        right: 0,
      }}
      onMouseLeave={() => {
        if (!props.isDocumentCenter) {
          props.setHoveredFile(null);
        }
      }}
    >
      <StyledCard>
        <CardContent>
          <FilePreview fileType={fileType} fileUrl={preSignedUrl} />
        </CardContent>
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
          }}
        >
          <Typography variant="h6">{fileData?.name}</Typography>
          {!props.isDocumentCenter && (
            <IconButton aria-label="more" aria-controls="file-menu" aria-haspopup="true" onClick={handleClick}>
              <img src={more.src} />
            </IconButton>
          )}
          <Menu id="file-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            {/* <MenuItem onClick={handleClose}>Open File</MenuItem> */}
            <MenuItem
              onClick={() => {
                handleDownloadFile(fileData?.externalId);
                handleClose();
              }}
            >
              Download File
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleDeleteFile(fileData?.externalId, props.hoveredRowId);
                handleClose();
              }}
              style={{ color: "red" }}
            >
              Delete File
            </MenuItem>
          </Menu>
        </CardActions>
      </StyledCard>
      <Triangle />
    </Container>
  );
};
const StyledCard = styled(Box)({
  width: "267px",
  padding: "12px",
  borderRadius: 10,
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  position: "relative",
  backgroundColor: "white",
  "&::after": {
    content: '""',
    position: "absolute",
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderTop: "10px solid white",
    bottom: "-10px",
    left: "calc(50% - 10px)",
  },
});

const Triangle = styled("div")({
  display: "none",
});

export default FilePreviewPopOver;
